<template>
  <div
    class="relative flex flex-col min-w-0 break-words bg-white rounded-lg border-blueGray-100 mb-6 xl:mb-0"
    :class="accentBorderClass"
    style="border-left-width: 3px;"
  >
    <div class="flex-auto p-4">
      <div class="flex flex-wrap">
        <div class="relative w-full pr-4 max-w-full flex-grow flex-1">
          <h5 class="text-blueGray-400 uppercase font-semibold text-xs tracking-wide">
            {{ statSubtitle }}
          </h5>
          <span class="font-semibold text-sm text-blueGray-700">
            {{ statTitle }}
          </span>
        </div>
        <div class="relative w-auto pl-4 flex-initial">
          <div
            class="text-white p-2 text-center inline-flex items-center justify-center w-10 h-10 rounded-lg"
            :class="[statIconColor]"
          >
            <i :class="[statIconName]" style="font-size: 14px;"></i>
          </div>
        </div>
      </div>
      <p class="text-xs text-blueGray-400 mt-3">
        <span class="mr-1 font-semibold" :class="[statPercentColor]">
          <i
            :class="[
              statArrow === 'up' ? `fas fa-arrow-up` : `fas fa-arrow-down`,
            ]"
            style="font-size: 10px;"
          ></i>
          {{ !!statPercent ? statPercent + "%" : statCount }}
        </span>
        <span class="whitespace-nowrap">{{ statDescripiron }}</span>
      </p>
    </div>
  </div>
</template>
<script>
export default {
  name: "card-stats",
  computed: {
    // Reuses the existing statIconColor prop (e.g. "bg-indigo-500") to color the
    // card's left accent bar too, so every existing call site gets the new look
    // for free without needing a separate color prop threaded through.
    accentBorderClass() {
      return (this.statIconColor || "").replace("bg-", "border-");
    }
  },
  props: {
    statSubtitle: {
      type: String,
      default: "Traffic",
    },
    statTitle: {
      type: String,
      default: "350,897",
    },
    statArrow: {
      default: "up",
      validator: function (value) {
        // The value must match one of these strings
        return ["up", "down"].indexOf(value) !== -1;
      },
    },
    statPercent: {
      type: String,
      // default: "3.48",
    },
    statCount: {
      type: String,
      // default: "20",
    },
    // can be any of the text color utilities
    // from tailwindcss
    statPercentColor: {
      type: String,
      default: "text-emerald-500",
    },
    statDescripiron: {
      type: String,
      default: "Since last month",
    },
    statIconName: {
      type: String,
      default: "far fa-chart-bar",
    },
    // can be any of the background color utilities
    // from tailwindcss
    statIconColor: {
      type: String,
      default: "bg-red-500",
    },
  },
};
</script>
